import React from 'react';
const AiChatSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.25581C4.72301 1.25581 1.25581 4.72301 1.25581 9C1.25581 10.24 1.54677 11.4102 2.06355 12.4477C2.27096 12.8641 2.35083 13.3621 2.21997 13.8512L1.72132 15.7148C1.62974 16.0571 1.94288 16.3703 2.28515 16.2787L4.14882 15.7801C4.63791 15.6492 5.13587 15.7291 5.5523 15.9364C6.58985 16.4533 7.76001 16.7442 9 16.7442C13.277 16.7442 16.7442 13.277 16.7442 9C16.7442 4.72301 13.277 1.25581 9 1.25581ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C7.56142 18 6.19997 17.662 4.9924 17.0606C4.8122 16.9708 4.62821 16.9517 4.47341 16.9932L2.60975 17.4918C1.33398 17.8331 0.166831 16.666 0.508186 15.3903L1.00683 13.5266C1.04825 13.3718 1.02921 13.1878 0.939458 13.0076C0.33799 11.8 0 10.4386 0 9Z"
        fill={color}
      />
      <path d="M12.292 6.23035V11.8929H11.1562V6.23035H12.292Z" fill={color} />
      <path
        d="M8.82102 10.814H6.56573L6.19255 11.893H5L7.03626 6.22229H8.3586L10.3949 11.893H9.1942L8.82102 10.814ZM8.51274 9.9054L7.69337 7.53653L6.874 9.9054H8.51274Z"
        fill={color}
      />
    </svg>
  );
};

export default AiChatSVG;
